import { createContext } from 'react'

export interface LayoutMultiLineContextType {
  isVideoBlock: boolean
  grid?: '4|2|2' | '2|2|4'
}

const LayoutMultiLineContext = createContext<
  LayoutMultiLineContextType | undefined
>(undefined)

const exports = { LayoutMultiLineContext }

export default exports
